import { render, staticRenderFns } from "./SearchBarComponent.vue?vue&type=template&id=50c2bbf8&scoped=true&"
import script from "./SearchBarComponent.vue?vue&type=script&lang=ts&"
export * from "./SearchBarComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBarComponent.vue?vue&type=style&index=0&id=50c2bbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2bbf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VTextField})
